module.exports = __webpack_public_path__ + "20b87981f0d32633986bd3b4ac4d4bd0.png";